// ⚠️ DIAGNÓSTICO TEMPORAL — borrar cuando se identifique la causa del jank.
//
// Sirve para localizar, EN EL DISPOSITIVO REAL y dentro del webview de Instagram/TikTok,
// qué provoca el tirón al hacer scroll. Todo se activa SOLO por query param: sin params
// este módulo no hace absolutamente nada y ningún visitante nota nada.
//
// Uso (añadir a la URL, se pueden combinar):
//   ?perf=1        → muestra el medidor de FPS/jank en pantalla
//   ?noclarity=1   → NO carga Microsoft Clarity (session recording)
//   ?notrack=1     → NO carga nada de tracking (GA4 + Meta Pixel + Clarity)
//   ?noblur=1      → desactiva TODOS los backdrop-filter (header escarchado incl.)
//   ?noglow=1      → no monta CursorGlow (fixed + mix-blend-mode)
//   ?novideo=1     → portada sin vídeo (solo afecta a "/")
//   ?nobarfix=1    → home en el móvil sin la capa data-ul-barclear (la barra de abajo de Safari de iOS 26 vuelve a salir navy)
//   ?perfoff=1     → limpia los flags recordados en esta pestaña
//
// Ejemplo: https://ulture.co/apps?perf=1&noclarity=1

const FLAG_KEYS = ["perf", "noclarity", "notrack", "noblur", "noglow", "novideo", "nobarfix"] as const;
export type PerfFlag = (typeof FLAG_KEYS)[number];

const STORE_KEY = "ulture-perf-flags";

function readFlags(): Set<string> {
  const out = new Set<string>();
  if (typeof window === "undefined") return out;
  try {
    const q = new URLSearchParams(window.location.search);

    if (q.has("perfoff")) {
      sessionStorage.removeItem(STORE_KEY);
      return out;
    }

    for (const k of FLAG_KEYS) {
      const v = q.get(k);
      if (v !== null && v !== "0" && v !== "false") out.add(k);
    }

    // El header navega con navigate() y pierde la query, así que los flags se
    // recuerdan en la pestaña: sobreviven a moverse entre / y /apps.
    if (out.size > 0) sessionStorage.setItem(STORE_KEY, [...out].join(","));
    else {
      const saved = sessionStorage.getItem(STORE_KEY);
      if (saved) saved.split(",").filter(Boolean).forEach((k) => out.add(k));
    }
  } catch {
    /* sin URL o sin sessionStorage: se queda sin flags */
  }
  return out;
}

const flags = readFlags();

export const hasPerfFlag = (f: PerfFlag): boolean => flags.has(f);
export const activePerfFlags = (): string[] => [...flags];

/**
 * Aplica los kill-switches que deben estar activos ANTES del primer paint
 * (para que el compositor no llegue a ver un backdrop-filter). Se llama desde
 * main.tsx. No depende de ?perf: se puede medir a ojo sin el overlay encima.
 */
export function installPerfKillSwitches(): void {
  if (typeof document === "undefined" || !flags.has("noblur")) return;
  const s = document.createElement("style");
  s.setAttribute("data-perf-kill", "noblur");
  s.textContent =
    "*,*::before,*::after{backdrop-filter:none!important;-webkit-backdrop-filter:none!important}";
  document.head.appendChild(s);
}
